// components
import PermissionEditorAbstract from '../PermissionEditorAbstract';

const allActions = ['receive-payment', 'make-payment', 'approve-merchant', 'approve-external-transaction'];

export default class ActionsEditor extends PermissionEditorAbstract {
    constructor(props) {
        super(props);

        this.Name = 'actionPermissions';
        this.Server = this.props.context.getState().server.actionPermissions;

        this.Head = [
            {
                id: 'permissionName',
                label: 'action',
                type: 'controller',
                alignRight: false,
                cell: 'Text',
                items: allActions,
                filterCell: 'Items',
                filterBy: 'action',
                needTranslate: true,
                needStyle: true,
                isSingle: true,
                displayGrid: true
            },
            // {
            //     id: 'roleId',
            //     label: 'role',
            //     object: 'role',
            //     items: config.systemRoles,
            //     filterCell: 'Items',
            //     filterBy: 'role',
            //     needStyle: true,
            //     isSingle: true,
            //     alignRight: false,
            //     cell: 'Text',
            //     needTranslate: true,
            //     displayGrid: true
            // },
            {
                id: 'allowed',
                label: 'allowed',
                alignRight: false,
                cell: 'EditorSelect',
                items: ["allow", "deny"],
                displayGrid: true

            }
        ];
    }
    saveCurrentData = () => {
        this.setState(
            (prevState) => ({
                currentValues: this.List.reduce((acc, cur) => {
                    acc[cur.id] = {
                        allowed: cur.allowed,
                    };
                    return acc;
                }, {})
            })
        );
    };
}
